function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0.295654,
  y: 24.0864,
  width: 125.409,
  height: 61.5745,
  rx: 4,
  fill: "#939393"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 12.7236,
  y: 8.91748,
  width: 95.4688,
  height: 61.5745,
  rx: 4,
  transform: "rotate(-4.80197 12.7236 8.91748)",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.1,
  d: "M0.295654 42.7739C0.295654 40.5648 2.08652 38.7739 4.29565 38.7739H36.4072C37.6772 38.7739 38.8717 39.377 39.6258 40.3989L42.0293 43.6561C42.7833 44.678 43.9779 45.281 45.2478 45.281H121.704C123.913 45.281 125.704 47.0719 125.704 49.281V113.86C125.704 116.07 123.913 117.86 121.704 117.86H4.29565C2.08651 117.86 0.295654 116.07 0.295654 113.86V42.7739Z",
  fill: "#161616"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.295654 51.2476C0.295654 49.0384 2.08652 47.2476 4.29565 47.2476H36.4332C37.6885 47.2476 38.8711 47.8369 39.6269 48.8392L42.0281 52.0236C42.7839 53.0259 43.9665 53.6152 45.2219 53.6152H121.704C123.913 53.6152 125.704 55.4061 125.704 57.6152V120.639C125.704 122.849 123.913 124.639 121.704 124.639H4.29565C2.08651 124.639 0.295654 122.849 0.295654 120.639V51.2476Z",
  fill: "#D1D1D1"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M66.0128 70.4087C52.0471 70.4087 50.0072 79.239 50.0072 84.2481C50.0072 84.2481 56.1793 84.2481 58.3761 84.2481C58.3761 81.6144 58.5854 77.2767 65.4374 77.2767C71.0342 77.2767 72.708 79.0841 72.708 81.7177C72.708 87.2948 59.9453 85.0743 59.9453 97.6743C63.3452 97.6743 65.8036 97.6743 68.5758 97.6743C68.5758 88.6374 81.0769 91.271 81.0769 81.9243C81.0769 75.521 76.7878 70.4087 66.0128 70.4087ZM68.4189 107.692V100.514H59.9453V107.692H68.4189Z",
  fill: "white"
});

var SvgEmptyIcon = function SvgEmptyIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 126,
    height: 125,
    viewBox: "0 0 126 125",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEmptyIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EmptyIcon.dd5a66e8.svg";
export { ForwardRef as ReactComponent };